import React from "react"
import { Link } from "react-router-dom"

const projects = [
  {
    number: "01",
    title: "#1 Google Sheets Invoicing Software",
    description:
      "Turn spreadsheet rows into client-ready invoices in minutes. Import from Google Sheets, customize branding and colors, preview live, then share a polished PDF—ideal for freelancers and teams who already live in Sheets.",
    image: "/image.png",
    imageAlt: "Google Sheets invoicing software — create and preview invoices",
    tag: "SheetBills",
    caseStudyPath: "/case-studies/sheetbills",
    anchorId: "selected-work-sheetbills",
  },
  {
    number: "02",
    title: "Concept of Thoughts",
    description:
      "A premium, minimalist brand identity featuring a refined logo mark and high-end mockups—designed to feel modern, confident, and memorable across print and digital touchpoints.",
    image: "/Logo%20on%20Card%20Mockup.png",
    imageAlt: "Concept of Thoughts logo on card mockup",
    tag: "Brand Identity",
    caseStudyPath: "/case-studies/concepts-of-thoughts",
    anchorId: "selected-work-concepts-of-thoughts",
  },
  {
    number: "03",
    title: "Romonia — ROMANA Premium Olive Oil",
    description:
      "A refined food brand identity and packaging direction—botanical mark, elegant serif wordmark, and a premium bottle presentation with a calm olive-and-gold palette built for shelf appeal and trust.",
    image: "/Romana_main.png",
    imageAlt: "ROMANA premium olive oil — brand identity and bottle mockup",
    tag: "Brand Identity",
    caseStudyPath: "/case-studies/romonia",
    anchorId: "selected-work-romonia",
  },
  {
    number: "04",
    title: "Ebenzer Drafting and Construction LTD",
    description:
      "A construction and architectural practice focused on drafting, build quality, and clear project delivery—from technical drawings through to on-site execution for residential and commercial clients.",
    image: "/Ebenzer.png",
    imageAlt: "Ebenzer Drafting and Construction",
    tag: "Construction",
    caseStudyPath: "/case-studies/ebenezer",
    anchorId: "selected-work-ebenezer",
  },
  {
    number: "05",
    title: "Palm Success",
    description:
      "A bold brand identity built for a growth-focused company—logo design, visual direction, and brand assets that feel premium, consistent, and easy to apply across social media, print, and web.",
    image: "/Palm_Sucess.png",
    imageAlt: "Palm Success brand identity",
    tag: "Brand Identity",
    caseStudyPath: "/case-studies/palm-success",
    anchorId: "selected-work-palm-success",
  },
  {
    number: "06",
    title: "Aurora Collection",
    description:
      "A luxury wordmark and logotype system—custom serif lettering, a distinctive central symbol, and refined “COLLECTION” pairing—crafted for high-end retail and editorial mockups with calm, editorial lighting.",
    image: "/Auroa.jpg",
    imageAlt: "Aurora Collection logo mockup on textured paper",
    tag: "Brand Identity",
    caseStudyPath: "/case-studies/aurora-collection",
    anchorId: "selected-work-aurora-collection",
  },
  {
    number: "07",
    title: "Shelmur Car Rentals",
    description:
      "A modern car rental web experience—bold hero, clear booking flow, and a polished UI that helps visitors find the right vehicle and move from browse to booking with confidence.",
    image: "/Shelmur.png",
    imageAlt: "Shelmur Car Rentals website hero and booking section",
    tag: "Web",
    caseStudyPath: "/case-studies/shelmur-car-rentals",
    anchorId: "selected-work-shelmur-car-rentals",
  },
]

export function SelectedWork() {
  return (
    <section
      id="selected-work"
      className="bg-white py-16 sm:py-20 lg:py-28"
    >
      <style>{`
        .selected-work-anchor {
          scroll-margin-top: 96px;
        }
        .work-tag {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          padding: 4px 10px;
          border: 1px solid #d4d4d4;
          border-radius: 999px;
          color: #666;
        }

        .main-image-wrap {
          position: relative;
          overflow: hidden;
          border-radius: 12px;
          background: #f0ede8;
        }

        .main-image-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .main-image-wrap:hover img {
          transform: scale(1.04);
        }

        .main-image-wrap.sheetbills-shadow {
          box-shadow:
            0 20px 52px rgba(4, 120, 87, 0.16),
            0 8px 18px rgba(4, 120, 87, 0.10);
        }

        .main-image-wrap.subtle-shadow {
          box-shadow:
            0 12px 26px rgba(255, 255, 255, 0.14),
            0 4px 10px rgba(255, 255, 255, 0.10);
        }

        .main-image-wrap.dark-shadow {
          box-shadow:
            0 16px 42px rgba(255, 255, 255, 0.18),
            0 6px 16px rgba(255, 255, 255, 0.12);
        }

        .divider-line {
          width: 100%;
          height: 1px;
          background: #e8e8e8;
        }

        .project-number {
          font-family: 'Playfair Display', Georgia, serif;
          font-style: italic;
          font-weight: 400;
          color: #c8c2b8;
          line-height: 1;
        }

        .view-link {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          font-weight: 500;
          color: #111;
          text-decoration: none;
          border-bottom: 1px solid #111;
          padding-bottom: 2px;
          transition: opacity 0.2s;
        }

        .view-link:hover {
          opacity: 0.5;
        }

        .arrow-icon {
          transition: transform 0.2s ease;
        }

        .view-link:hover .arrow-icon {
          transform: translate(3px, -3px);
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12 lg:mb-16">
          <div>
            <p className="work-tag mb-4">Portfolio</p>
            <h2
              style={{ fontWeight: 700, lineHeight: 1.1 }}
              className="text-4xl sm:text-5xl md:text-6xl text-black"
            >
              Selected<br />
              <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontStyle: "italic", fontWeight: 400, color: "#b91c1c" }}>Work</span>
            </h2>
          </div>
          <span
            className="project-number text-6xl sm:text-7xl md:text-8xl"
            style={{ letterSpacing: "-0.02em" }}
          >
            2026
          </span>
        </div>

        <div className="divider-line mb-12 lg:mb-16" />

        {/* Projects */}
        {projects.map((project, index) => (
          <React.Fragment key={project.number}>
            <div
              id={project.anchorId}
              className="grid lg:grid-cols-[1fr_1.2fr] gap-8 lg:gap-16 items-center mb-16 lg:mb-20 selected-work-anchor"
            >

              {/* Text */}
              <div className={`order-2 ${index % 2 === 1 ? "lg:order-2" : "lg:order-1"} space-y-6`}>
                <span className="project-number text-7xl sm:text-8xl">{project.number}</span>
                <div className="space-y-3">
                  <p className="work-tag">{project.tag}</p>
                  <h3
                    style={{ fontWeight: 700, lineHeight: 1.15 }}
                    className="text-3xl sm:text-4xl text-black"
                  >
                    {project.title}
                  </h3>
                </div>
                <p style={{ color: "#555", lineHeight: 1.75, fontSize: "15px" }}>
                  {project.description}
                </p>
                <Link to={project.caseStudyPath} className="view-link">
                  View case study
                  <svg className="arrow-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M7 17L17 7M17 7H7M17 7v10" />
                  </svg>
                </Link>
              </div>

              {/* Image */}
              <div
                className={`order-1 ${index % 2 === 1 ? "lg:order-1" : "lg:order-2"} main-image-wrap aspect-[4/3] ${
                  project.number === "01"
                    ? "sheetbills-shadow"
                    : project.number === "02"
                      ? "subtle-shadow"
                      : "dark-shadow"
                }`}
              >
                <img src={project.image} alt={project.imageAlt} />
              </div>
            </div>

            {index !== projects.length - 1 ? (
              <div className="divider-line mb-12 lg:mb-16" />
            ) : null}
          </React.Fragment>
        ))}

      </div>
    </section>
  )
}